import React from "react";
import "./RefundPolicy.css";

const RefundPolicy = () => {
  return (
    <div className="refund-container">
      <div className="refund-card">
        <h1>Refund Policy</h1>

        <p className="effective-date">
          <strong>Effective Date:</strong> May 2026
        </p>

        <section>
          <p>
            Due to the digital and instant-access nature of our products and
            services, all sales are final and non-refundable unless otherwise
            specified.
          </p>
        </section>

        <section>
          <h2>Exceptions</h2>

          <div className="policy-box">
            <h3>Digital Products & Templates</h3>
            <p>
              No refunds after purchase and download/access has been granted.
            </p>
          </div>

          <div className="policy-box">
            <h3>Training Programs & Mentorship</h3>
            <p>
              Refunds may be considered within 7 days of purchase only if no
              materials have been accessed.
            </p>
          </div>

          <div className="policy-box">
            <h3>Custom Development, Software Projects & Expert Hiring</h3>
            <p>
              No refunds once work has commenced. Any exceptions are at our sole
              discretion based on project stage.
            </p>
          </div>
        </section>

        <section>
          <h2>Refund Request Process</h2>

          <ul>
            <li>
              Submit requests in writing via email within the allowed period.
            </li>

            <li>
              Include your order number and detailed reason.
            </li>

            <li>
              Approved refunds will be processed within 10–14 business days to
              the original payment method.
            </li>
          </ul>
        </section>

        <section>
          <h2>Chargebacks</h2>

          <p>
            Unauthorized chargebacks or disputes without first contacting us
            may result in account suspension or permanent ban from our platform.
          </p>
        </section>

        <section className="highlight-section">
          <p>
            We are committed to delivering outstanding quality and value. If you
            experience any issues with your purchase, please reach out — we will
            do our best to resolve them fairly.
          </p>
        </section>

        <section className="contact-section">
          <h2>Contact Us</h2>

          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:Ceo.abiola@wdh.it.com">
              ericdobulertwin26@gmail.com
            </a>
          </p>

          <p>
            <strong>Phone:</strong>  +1 (805) 475-3211 OR +1 (914) 691-6155
          </p>
        </section>
      </div>
    </div>
  );
};

export default RefundPolicy;